import BossModel from "@/models/BossModel";

export default class ResidenceType extends BossModel {

    /**
     * @type {string}
     */
    static apiUrl = 'residence-type';

    /**
     * @type {string}
     */
    static entity = 'residenceTypes';

    static fields() {
		return {
			id: this.attr(null),
			name: this.attr(null),
			code: this.attr(null),
			is_active: this.attr(null),
		}
	}

    /**
     * @returns {*}
     */
    static fetchAllForSelect() {
        return this.api().limit(0).where('is_active', true).get(true);
    }

    /**
     *
     * @returns {Promise<unknown>}
     */
    static loadAll() {
        return this.api().limit(0).where('is_active', true).get();
    }
}
